import React from 'react';
import './style.scss';
import { NavbarItemProps } from '../navbar-item/interface';

const NavbarSubitem = (props: NavbarItemProps) => {
  const { size = 'normal' } = props;
  
  const isActive = (link: string) => {
    return link === props.location.pathname || props.location.pathname.startsWith(link + '/');
  };

  if (!props.renderLink) {
    console.error('NavbarSubitem: renderLink function is required to render links.');
    return null; // Provide a fallback if renderLink is not provided
  }

  return (
    <div className={`navbar-subitem navbar-subitem--${size} ${isActive(props.link.url) ? 'active' : ''}`}>
      {props.renderLink(props.link, (
        <div className="navbar-link">{props.link.text}</div>
      ))}
    </div>
  );
};

export default NavbarSubitem;
